
var Fifo = function (maxSize, seed) {
    this._content = [];
    this.maxSize = maxSize !== undefined ? maxSize : Number.POSITIVE_INFINITY;

    if (seed !== undefined) {
        for (var i=0; i<this.maxSize; i++) {
            this.enqueue(seed);
        }
    }
};

Fifo.prototype.enqueue = function(element) {
    this._content.unshift(element);
    if (this._content.length > this.maxSize) var out = this._content.pop();
    return out;
};

Fifo.prototype.dequeue = function() {
    return this._content.pop();
};

Fifo.prototype.size = function(){
    return this._content.length;
};

Fifo.prototype.isEmpty = function(){
    return this._content.length === 0;
};

Fifo.prototype.head = function(){
    return this._content[this._content.length - 1];
};

Fifo.prototype.read = function(index) {
    return this._content[index];
};

Fifo.prototype.write = function(index, element) {
    this._content[index] = element;
};

module.exports = Fifo;